namespace Roodik.Game
{
	import ViewBase = Roodik.Core.ViewBase;
	export class TilePreview extends ViewBase
	{
		private _icon:IconView;

		constructor(private _model:ITileModel)
		{
			super("TilePreview");

			this._icon = new IconView(this._model.type);
			this.addChild(this._icon);
		}

		public destroy()
		{
			this.removeChild(this._icon);
			this._icon.destroy();
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Game/View/Board/TilePreview.ts